import { Modal } from 'react-bootstrap';
import { useState } from 'react';
import { UserAvatar } from '../components';

function UserThumbnails(props) {
  const {
          users,
          limit,
          disable_users_info,
          tooltip,
          openPopup,
          workspace_id,
          organization_id,
          openUserSummary,
          className,
          avatarBorderColor= 'white',
          hoverableOnly = false,
          size // small, 
        } = props
  const [show, setShow] = useState(false);

  const tooltipHandler = (name) => {
    return {
      'data-toggle': "tooltip",
      title: name
    }
  }

  const avatarSize = () => {
    switch (size) {
      case 'small':
        return 18;
      default:
        return 30;
    }
  }

  const expandedUsers = (users && limit && users.length > limit) ? users.slice(0, limit) : users
  const collapsedUsers = (users && limit) ? users.slice(limit, users.size) : []

  // WORKAROUND: The child items are reversed so that we can apply negative margin and have the
  // first user overlap over the second item, and not the other way around, without using z-index.
  // Rendering of items are reversed through "flex-direction: row-reverse".
  return (
    <div className={`${className} user-thumbnails`}>
      { users &&
        <>
          {
            Array.from(expandedUsers).map((user, index) =>(
              <div
                className={`custom-tooltip ${index === Array.from(expandedUsers).length - 1 ? 'last-user' :  'mr-1'} `}
                key={ 'user_thumbnail_'+user?.id}
                {...tooltipHandler(user?.name)}
                style={{
                  zIndex: index,
                  border: `3px solid ${avatarBorderColor}`,
                  borderRadius: '50%',
                  borderRight: '0', // To avoid double border on the left side of the first avatar
                  background: avatarBorderColor,
                  ...(index === 0 ? {} : {}),
                }}
              >
                <UserAvatar
                  icon={ user?.logo?.icon?.url ? user.logo.icon.url : null }
                  name={ user?.name }
                  name_initials={ user?.name_initials }
                  user_id={ user?.id }
                  size={avatarSize()}
                  workspace_id={workspace_id}
                  organization_id={organization_id}
                  openUserSummary={openUserSummary}
                  hoverableOnly={true}
                 />
              </div>
            ))
          }

          { collapsedUsers && collapsedUsers.length > 0 &&
            <div 
              className="more-users"
              style={{
                  zIndex: expandedUsers.length - collapsedUsers.length,
                  border: `3px solid ${avatarBorderColor}`,
                  borderRadius: '50%',
                  borderRight: '0',
                  background: avatarBorderColor
                }}
            >
              <div className="btn-more_participants" onClick={() => disable_users_info == undefined && setShow(true)}>
                +{collapsedUsers.length}
              </div>
            </div>
          }

          {
            openPopup !== undefined && openPopup !== null &&
              <div 
                className="more-users"
                 style={{
                  zIndex: expandedUsers.length - collapsedUsers.length,
                  border: `3px solid ${avatarBorderColor}`,
                  borderRadius: '50%',
                  borderRight: '0',
                  background: avatarBorderColor
                }}
              >
                <div className="btn-more_participants" onClick={openPopup}>
                  <i className="fa fa-plus" aria-hidden="true"></i>
                </div>
              </div>
          }

        </>
      }

      <Modal
        show={show}
        onHide={() => setShow(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Participants</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="more-users_panel">
            <ul>
            { users &&
              users.map((user, index) =>(
                <li className="" key={user.id}>
                  <UserAvatar icon={ user?.logo?.url ? user.logo.url : null } name={ user?.name } name_initials={ user?.name_initials } size={avatarSize()} />
                  {user?.name}
                </li>
              ))
            }
            </ul>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export { UserThumbnails };
